import { render, staticRenderFns } from "./FragmentDstream.vue?vue&type=template&id=21893d82"
import script from "./FragmentDstream.vue?vue&type=script&lang=ts"
export * from "./FragmentDstream.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports